import { useCallback, useEffect, useState } from "react";

/* Ctrl/Cmd+K is what people already try, and "/" is the second guess — but only
 * when they are not typing into something, or the palette would open every time
 * someone types a slash into a task title. */
const isTypingTarget = (target) => {
  if (!target) return false;
  const tag = target.tagName;
  return (
    tag === "INPUT" ||
    tag === "TEXTAREA" ||
    tag === "SELECT" ||
    target.isContentEditable
  );
};

export const useCommandPalette = () => {
  const [open, setOpen] = useState(false);

  const close = useCallback(() => setOpen(false), []);
  const toggle = useCallback(() => setOpen((state) => !state), []);

  useEffect(() => {
    const onKeyDown = (event) => {
      const combo = event.metaKey || event.ctrlKey;

      if (combo && event.key?.toLowerCase() === "k") {
        event.preventDefault();
        toggle();
        return;
      }

      if (event.key === "/" && !combo && !isTypingTarget(event.target)) {
        event.preventDefault();
        setOpen(true);
      }
    };

    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [toggle]);

  return { open, setOpen, close, toggle };
};

export default useCommandPalette;
